import { render, staticRenderFns } from "./LearnGearInch.vue?vue&type=template&id=074e1040&scoped=true&"
import script from "./LearnGearInch.vue?vue&type=script&lang=js&"
export * from "./LearnGearInch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e1040",
  null
  
)

export default component.exports